import React, { useEffect, useState } from "react";
import { InspectionImageType } from "@/enums/InspectionImage.enum";
import { FileDetails, Image } from "@/types/Image.type";
import { DynamicComponentProps } from "@/types/ModuleComponentProp.type";
import { Images2 } from '@/features/components/images-2/Images2.tsx';
import { ImageCategory } from "@/store/slices/masterDataSlice";
import { useImageCategories } from "@/hooks/masterData";

export const InspectionImagesV2: React.FC<DynamicComponentProps> = ({
	inspection,
	inspectionImageHandlers
}: DynamicComponentProps) => {

	const { imageCategories } = useImageCategories();
	const [selectedLabelType, setSelectedLabelType] = useState<string>(
		imageCategories?.find((i: ImageCategory) => i.isDefault)?.imageCategoryName || imageCategories?.[0]?.imageCategoryName || '');

	useEffect(() => {
		if (inspectionImageHandlers?.loadImages) {
			inspectionImageHandlers.loadImages();
		}
	}, []);

	async function onAdd(file: FileDetails): Promise<void> {
		if (inspectionImageHandlers?.onAdd) {
			const newImage = { type: InspectionImageType.FULL_PRODUCT, isNew: true, ...file };
			inspectionImageHandlers.onAdd(newImage, InspectionImageType.FULL_PRODUCT);
		}
	}

	async function onRemove(img: Image): Promise<void> {
		if (inspectionImageHandlers?.onDelete) {
			inspectionImageHandlers.onDelete(img, InspectionImageType.FULL_PRODUCT);
		}
	}
	return (
		<Images2
			selectedLabelType={selectedLabelType}
			type={InspectionImageType.FULL_PRODUCT}
			setSelectedLabelType={setSelectedLabelType}
			inspectionId={inspection?.id || ''}
			images={inspection.fpImages || []}
			onAdd={onAdd}
			onRemove={onRemove}
			imageTypes={imageCategories?.map((i: ImageCategory) => { return { name: i.imageCategoryName, order: i.displayOrder } }) || []}
		/>
	);
};
